import React from 'react';






function AmountDue({
  totalAmountDue,
  getCurrencyIcon
}) {
  const currencyIcon = getCurrencyIcon();

  return (
    <span style={{ color: '#fff' }}>
      Pay
      {' '}
      {currencyIcon}
      {totalAmountDue}
      {' '}
      now
    </span>);

}

export default AmountDue;